export const CURRENCIES = [
  { code: 'MXN', symbol: '$', name: 'Peso Mexicano', flag: '🇲🇽' },
  { code: 'USD', symbol: '$', name: 'Dólar Americano', flag: '🇺🇸' },
  { code: 'EUR', symbol: '€', name: 'Euro', flag: '🇪🇺' },
  { code: 'GBP', symbol: '£', name: 'Libra Esterlina', flag: '🇬🇧' },
  { code: 'CAD', symbol: '$', name: 'Dólar Canadiense', flag: '🇨🇦' },
  { code: 'AUD', symbol: '$', name: 'Dólar Australiano', flag: '🇦🇺' },
  { code: 'JPY', symbol: '¥', name: 'Yen Japonés', flag: '🇯🇵' },
  { code: 'BRL', symbol: 'R$', name: 'Real Brasileño', flag: '🇧🇷' },
  { code: 'ARS', symbol: '$', name: 'Peso Argentino', flag: '🇦🇷' },
  { code: 'COP', symbol: '$', name: 'Peso Colombiano', flag: '🇨🇴' },
  { code: 'CLP', symbol: '$', name: 'Peso Chileno', flag: '🇨🇱' },
  { code: 'PEN', symbol: 'S/', name: 'Sol Peruano', flag: '🇵🇪' },
  { code: 'CZK', symbol: 'Kč', name: 'Corona Checa', flag: '🇨🇿' },
  { code: 'SEK', symbol: 'kr', name: 'Corona Sueca', flag: '🇸🇪' },
  { code: 'CHF', symbol: 'Fr', name: 'Franco Suizo', flag: '🇨🇭' },
];

export const DEFAULT_CURRENCY = 'MXN';

export function getCurrency(code) {
  return CURRENCIES.find(c => c.code === code) || CURRENCIES[0];
}

export function formatCurrency(amount, currencyCode) {
  const code = currencyCode || DEFAULT_CURRENCY;
  if (amount === null || amount === undefined || isNaN(amount)) return '—';
  try {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: code,
      minimumFractionDigits: ['JPY', 'CLP'].includes(code) ? 0 : 2,
      maximumFractionDigits: ['JPY', 'CLP'].includes(code) ? 0 : 2,
    }).format(amount);
  } catch {
    const cur = getCurrency(code);
    return `${cur.symbol}${Number(amount).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}
